import { createContext, ReactNode, useContext } from 'react';
import { UseQueryResult } from 'react-query';
import {
  GetQuestionTypesQuery,
  useGetQuestionTypesQuery,
} from 'src/graphql/generated';

type QuestionTypesContextValue = UseQueryResult<GetQuestionTypesQuery, unknown>;

const QuestionTypesContext = createContext<QuestionTypesContextValue | null>(
  null,
);

interface QuestionTypesProviderProps {
  children: ReactNode;
  formCategoryId?: string;
}

export function QuestionTypesProvider({
  children,
  formCategoryId,
}: QuestionTypesProviderProps) {
  const questionTypesQuery = useGetQuestionTypesQuery(
    { formCategoryId },
    {
      staleTime: 5 * 60 * 1000,
      cacheTime: 30 * 60 * 1000,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    },
  );

  return (
    <QuestionTypesContext.Provider value={questionTypesQuery}>
      {children}
    </QuestionTypesContext.Provider>
  );
}

export function useQuestionTypes(): QuestionTypesContextValue {
  const context = useContext(QuestionTypesContext);
  if (!context) {
    throw new Error(
      'useQuestionTypes must be used within QuestionTypesProvider',
    );
  }
  return context;
}
